import ManageContacts from './ManageContacts';

export default ManageContacts;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/WellData/ManageContacts/index.tsx